import { Card, Grid, Box } from "@mui/material";
import ByzCard from "src/components/core-components/ByzCard";
import ByzTitleBox from "src/components/core-components/ByzTitleBox";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";

interface WongBakerScaleProps {
  t: (key: string) => string;
  cardData: any;
  handleChange: (key: string, value: any) => void;
  typedFormData: Record<string, any>;
}

const WongBakerScale: React.FC<WongBakerScaleProps> = ({ t, cardData, handleChange , typedFormData}) => {
  const cardWidth = 160;

  const smiles = [
    { value: 0, src: "/assets/icons/smiles/smile-0.svg", label: "Ağrı Yok", color: "#28a745" },
    { value: 1, src: "/assets/icons/smiles/smile-1.svg", label: "Ağrı Biraz", color: "#ffc107" },
    { value: 2, src: "/assets/icons/smiles/smile-2.svg", label: "Biraz Daha Fazla", color: "#fd7e14" },
    { value: 3, src: "/assets/icons/smiles/smile-3.svg", label: "Daha Fazla", color: "#f8d7da" },
    { value: 4, src: "/assets/icons/smiles/smile-4.svg", label: "Oldukça Fazla", color: "#dc3545" },
    { value: 5, src: "/assets/icons/smiles/smile-5.svg", label: "En Şiddetli", color: "#842029" },
  ];

  const cardStyle = (smileValue: number) => ({
    width: cardWidth,
    padding: 1,
    borderWidth: "2px",
    borderStyle: "solid",
    borderColor: typedFormData?.WONG_BAKER_SCALE_SCORE === smileValue ? "#1976d2" : "#8D8D8D", 
    backgroundColor: typedFormData?.WONG_BAKER_SCALE_SCORE === smileValue ? "#E3F2FD" : "#FFFFFF",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    cursor: "pointer",
    transition: "border-color 0.2s ease-in-out",
    "&:hover img": {
      filter: `drop-shadow(0 0 10px ${smiles[smileValue].color})`,
    },
  });

  const handleCardClick = (value: number) => {
    handleChange('WONG_BAKER_SCALE_SCORE',value);
  };

  return (
    <ByzCard sx={{ mt: 3, mb: 5 }}>
      <ByzTitleBox title={t("pain-assessment-scale.wong-baker-scale.title")} />

      <ByzCard sx={{ ml: 1, mb: 1, display: "flex", gap: 1, flexWrap: "wrap" }}>
        {smiles.map((smile) => (
          <Card
            key={smile.value}
            sx={cardStyle(smile.value)}
            onClick={() => handleCardClick(smile.value)}
          >
            <Box
              component="img"
              src={smile.src}
              alt={smile.label}
              sx={{
                width: 50,
                height: 50,
                mb: 1,
                transition: "all 0.1s ease-in-out",
              }}
            />
            <ByzMuiTypography fontWeight={400}>{smile.label}</ByzMuiTypography>
          </Card>
        ))}
      </ByzCard>

      {/* Skor Bilgisi */}
      <ByzCard sx={{ padding: 0, ml: 1, mt: 0 }}>
        <Grid container spacing={2} p={2}>
          <Grid item xs={12} sm={6}>
            <ByzMuiTypography fontWeight={400}>
              0 - Ağrı Yok , 1-2 Çok Hafif Ağrı , 3-4 Hafif Ağrı, 5-6 Orta Şiddetli Ağrı, 9-10 Çok Şiddetli Ağrı
            </ByzMuiTypography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <ByzMuiTypography fontWeight={400}>Skor : 1</ByzMuiTypography>
          </Grid>
        </Grid>
      </ByzCard>
    </ByzCard>
  );
};

export default WongBakerScale;
